







































import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'KEProductDescription',
  props: {
    description: {
      type: String,
      required: true,
      default: ''
    },
    brandDescription: {
      type: String,
      default: ''
    },
    fileList: {
      type: Array,
      default: () => []
    }
  }
});
